import { render, staticRenderFns } from "./SignsExplained.vue?vue&type=template&id=794c810c&scoped=true&lang=html&"
import script from "./SignsExplained.vue?vue&type=script&lang=js&"
export * from "./SignsExplained.vue?vue&type=script&lang=js&"
import style0 from "./SignsExplained.vue?vue&type=style&index=0&id=794c810c&lang=css&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "794c810c",
  null
  
)

export default component.exports